import React from 'react'
import { Heading, HeadingLevel } from 'baseui/heading';
import { Button, SHAPE, KIND } from "baseui/button";
import ArrowLeft from 'baseui/icon/arrow-left';
import { useNavigate } from "react-router-dom";

const HeadingSection = ({ level = 4, title, headerClass = 'mb-5', iconEnabled = false, backUrl = "/" }) => {
    let navigate = useNavigate();

    return (
        <div className={`relative ${headerClass}`}  >
            <div className='w-full flex justify-center'>
                <HeadingLevel>
                    <Heading styleLevel={level}>{title}</Heading>
                </HeadingLevel>
            </div>
            <div className='absolute -top-1 left-0' >
                {
                    iconEnabled ?
                        <Button shape={SHAPE.square} kind={KIND.secondary} onClick={() => navigate(backUrl)} >
                            <ArrowLeft size={24} />
                        </Button> : <div />
                }
            </div>
        </div>
    )
}

export default HeadingSection